import { useMemo } from 'react';
import { SelectedValues } from '@/components/shared/FilterAndSearchPanel/FilterAndSearchPanel';
import { formatRemoveSpaceUpperCase, upperSnakeCase } from '@/utils';

const staticFilters = new Set([
  'isGoverning',
  'paintRegion',
  'isVerified',
  'accessibility',
  'status',
  'isManuallyCreated',
  'unAssignedPoi',
  'mediaAttachment',
  'selectedDeckIds',
]);

export function useMappedFilters(selectedFilterValues: SelectedValues) {
  const selectedPoiFilters = useMemo(() => {
    return Object.entries(selectedFilterValues)
      .filter(([key]) => !staticFilters.has(key))
      .map(([key, value]) => ({ id: key, value: value }));
  }, [selectedFilterValues]);

  const isGoverningFilters = useMemo(() => {
    return selectedFilterValues.isGoverning?.map((item) => item.toLowerCase() === 'yes');
  }, [selectedFilterValues]);

  const isVerifiedFilters = useMemo(() => {
    return selectedFilterValues.isVerified?.map((item) => item.toLowerCase() === 'verified');
  }, [selectedFilterValues]);

  const accessibilityFilters = useMemo(() => {
    return selectedFilterValues.accessibility?.map((item) => upperSnakeCase(item));
  }, [selectedFilterValues]);

  const statusFilters = useMemo(() => {
    return selectedFilterValues.status?.map((item) => formatRemoveSpaceUpperCase(item));
  }, [selectedFilterValues]);

  const deckFilters = useMemo(() => {
    return selectedFilterValues.selectedDeckIds;
  }, [selectedFilterValues]);

  const isManuallyCreatedFilters = useMemo(() => {
    return selectedFilterValues.isManuallyCreated?.map((item) => item.toLowerCase() === 'yes');
  }, [selectedFilterValues]);

  const unAssignedPoiFilters = useMemo(() => {
    return selectedFilterValues.unAssignedPoi?.map((item) => item.toLowerCase() === 'yes');
  }, [selectedFilterValues]);

  const mediaAttachmentFilters = useMemo(() => {
    return selectedFilterValues.mediaAttachment?.map((item) => item.toLowerCase() === 'yes');
  }, [selectedFilterValues]);

  return {
    selectedPoiFilters,
    isGoverningFilters,
    isVerifiedFilters,
    accessibilityFilters,
    statusFilters,
    deckFilters,
    isManuallyCreatedFilters,
    unAssignedPoiFilters,
    mediaAttachmentFilters,
  };
}
